export default __webpack_public_path__ + "static/chunks/ui-assets/pattern-grid-black/04a256f55b4f96af7bee0517e99e5277.png";